import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ICustomMenu from "models/CustomMenu";
import { StyledMenu } from "./StyledMenu";



export const FeedbackActionButton = ({ anchorEl, open, handleClose }: ICustomMenu) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const openEditDialog = () => {
    setOpenDialog(true);
    handleClose();
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const openDeleteConfirmationDialog = () => {
    setDeleteConfirmationOpen(true);
    handleClose();
  };

  const closeDeleteConfirmationDialog = () => {
    setDeleteConfirmationOpen(false);
  };

  const handleDelete = () => {
    closeDeleteConfirmationDialog();
  };

  return (
    <>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{ "aria-labelledby": "demo-customized-menu" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={openEditDialog} disableRipple>
          <EditIcon />
          Edit
        </MenuItem>
        <MenuItem onClick={openDeleteConfirmationDialog} disableRipple>
          <DeleteIcon />
          Delete
        </MenuItem>
      </StyledMenu>

      {/* Edit Dialog here */}

      <Dialog open={openDialog} onClose={closeDialog}>
        <DialogTitle>Edit Form</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Edit Feedback Content Here ...</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={closeDialog} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog here */}

      <Dialog
        open={deleteConfirmationOpen}
        onClose={closeDeleteConfirmationDialog}
      >
        <DialogTitle style={{ backgroundColor: "#f44336", color: "white" }}>
          <Typography variant="h6" color="inherit" fontWeight={800}>
            Confirmation
          </Typography>
        </DialogTitle>
        <DialogContent style={{ padding: "16px 32px" }}>
          <Typography variant="body1">Are you sure you want to delete Feedback ?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteConfirmationDialog} color="error">
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
